import React from 'react';
import { InventoryNav } from './InventoryNav';
import { InventoryFooter } from './InventoryFooter';
interface InventoryLayoutProps {
  children: React.ReactNode;
}
export function InventoryLayout({
  children
}: InventoryLayoutProps) {
  return <div className="min-h-screen flex flex-col bg-white" data-id="element-88">
      {/*
          Spacer for fixed InventoryNavigation (rendered in App.tsx).
          Fixed nav is 72px tall.
        */}
      <div className="pt-[72px]" data-id="element-89" />
      <InventoryNav data-id="element-90" />
      <div className="flex-grow" data-id="element-91">{children}</div>
      <InventoryFooter data-id="element-92" />
    </div>;
}